import React, {Component} from 'react';
import axios from 'axios';
import guideMistakes from '../../assets/svg/icon-download.svg';
import guideMedicare from '../../assets/medicare-download.jpg';
import { Cookies } from 'react-cookie';

class Guide extends Component {
  state = {
    url: `${process.env.REACT_APP_API_URL}/services/guide`,
    area: this.props.area,
    first_name: '',
    last_name: '',
    email: '',
    marketingSource: '',
    formErrors: {},
    success: false,
    submitting: false
  };

  componentDidMount () {
    const cookies = new Cookies();
    const MarketingCampaignSource = (cookies.get('CDPHP_Marketing_Campaign_Source')) ? cookies.get('CDPHP_Marketing_Campaign_Source') : 'Not Set';
    console.log(MarketingCampaignSource);
    this.setState({
      marketingSource: MarketingCampaignSource
    });
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit = (event) => {
    const LeadSource = (this.state.area === 'EmployerGuide') ? 'funnel_smallbiz_download' : 'funnel_consumer_download';

    event.preventDefault();
    const formResults = {
      'area': this.state.area,
      'first_name': this.state.first_name,
      'last_name': this.state.last_name,
      'email': this.state.email,
      'Lead_Source__c': LeadSource,
      'Campaign__c': this.state.marketingSource.leadCampaign,
      'Content__c': this.state.marketingSource.leadContent,
      'Medium__c': this.state.marketingSource.leadMedium,
      'Source__c': this.state.marketingSource.leadSource,
      'GCLID__c': this.state.marketingSource.leadGCLID
    };

    console.log(formResults);
    const errors = this.validateForm(formResults);
    const isDisabled = Object.keys(errors).some(x => errors[x]);

    if (!isDisabled) {
      this.setState({submitting: true});
      console.log(formResults);
      axios.post(
        this.state.url, formResults
      ).then(response => {
        this.setState({submitting: false});
        this.setState({success: true});
        this.resetForm();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formID': 'Plans Microsite - Top 5 ' + this.state.area + ' Download'
        });
      }).catch(error => {
        console.error('Error Message: ' + error);
      });
    } else {
      this.setState({formErrors: errors});
    }
  }

  validateForm = (formResults) => {
    let formErrors = {};

    if (formResults.first_name.length < 2) {
      formErrors.first_name = 'Required';
    }

    if (formResults.last_name.length < 2) {
      formErrors.last_name = 'Required';
    }

    if (!formResults.email) {
      formErrors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formResults.email)) {
      formErrors.email = 'Invalid email address';
    }

    return formErrors;
  }

  closeForm = () => {
    this.resetForm();
    this.props.closeModal();
    var that = this;
    setTimeout(() => {
      that.setState({
        success: false
      });
    }, 500);
  }

  resetForm = () => {
    this.setState({
      formErrors: {},
      first_name: '',
      last_name: '',
      email: ''
    });
  }

  render () {
    const display = (this.props.show === true ? 'show' : '');
    const guideImage = (this.props.area === 'MedicareGuide') ? guideMedicare : guideMistakes;
    const guideClassName = (this.props.area === 'MedicareGuide') ? ' medicare' : '';

    let guideDownload;
    if (this.props.area === 'EmployerGuide') {
      guideDownload = '/pdf/CDPHP_Top-5-Mistakes-Companies-Make.pdf';
    } else if (this.props.area === 'MedicareGuide') {
      guideDownload = '/pdf/CDPHP_Top-5-Medicare-Mistakes.pdf';
    } else {
      guideDownload = '/pdf/CDPHP_Top-5-Mistakes-Health-Plans.pdf';
    }

    let Success = null;

    if (this.state.success) {
      Success = (
        <div id='success' className={this.state.success ? 'show' : ''}>
          <div>
            <h4>Thanks!</h4>
            {/* <p><em>{this.props.guideTitle}</em> has been sent to your email.</p> */}
            <p><a href={guideDownload} target='_blank' rel='noreferrer'>Download</a> your <em>{this.props.guideTitle}</em>.</p>
          </div>
        </div>
      );
    }

    return (
      <section className={'modal ' + display}>
        <div id='overlayBG' onClick={this.closeForm}>
          <div id='overlay' onClick={(event) => { event.stopPropagation(); }}>
            <div className='wrap sm text-center'>

              <div className={'guide' + guideClassName + (this.state.submitting ? ' loading' : '')}>
                <button className='close' onClick={this.closeForm}>Close</button>
                <img src={guideImage} alt='' className='guide-icon' />
                <form onSubmit={this.handleSubmit}>
                  <h4>Happy&nbsp;reading!</h4>
                  <p>
                    <label>My name is</label>
                    <span className='inputContainer'>
                      <input
                        name='first_name'
                        id='first_name'
                        type='text'
                        placeholder='First'
                        className={'first_name ' + (this.state.formErrors.first_name ? 'error' : '')}
                        value={this.state.first_name}
                        onChange={this.handleInputChange} />
                    </span>
                    <span className='inputContainer'>
                      <input
                        name='last_name'
                        id='last_name'
                        type='text'
                        placeholder='Last'
                        className={'last_name ' + (this.state.formErrors.last_name ? 'error' : '')}
                        value={this.state.last_name}
                        onChange={this.handleInputChange} />
                    </span>
                  </p>

                  <p>
                    <label>My email address is</label>
                    <span className='inputContainer'>
                      <input
                        name='email'
                        id='email'
                        type='text'
                        className={'email ' + (this.state.formErrors.email ? 'error' : '')}
                        placeholder='you@here.com'
                        value={this.state.email}
                        onChange={this.handleInputChange} />
                    </span>
                  </p>

                  <p className='pardot_extra_field'>
                    <label htmlFor='pardot_extra_field'>Comments</label>
                    <input type='text' id='pardot_extra_field' name='pardot_extra_field' />
                  </p>

                  <p className='submitForm'>
                    <input type='submit' value='Access Guide' className='btn' />
                  </p>
                </form>
                {Success}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Guide.propTypes = { // validate props expected
};

export default Guide;



// WEBPACK FOOTER //
// ./src/components/Forms/Guide.jsx